<template>
    <ss-modal
            v-show="modal"
            title="Title"
            v-if="guarantee"
            intro="bounceIn"
            outro ="bounceOut">
        <!-- HEADER -->
        <div slot = "modal-header">
            Zabezpieczenie <span class="text-primary">{{ guarantee.id }}</span>
        </div>
        <!-- BODY -->
        <div
          slot = "modal-body"
          class="text-center">
          <template v-for="(field, fieldIndex) in fieldsForType">
            <h2
              v-if="fieldsForType.includes('pledge_type') && field === 'street'"
              class="modal-table-separator mt-4 mb-3">
              Położenie zastawu
            </h2>
            <h2
              v-else-if="field === 'company'"
              class="modal-table-separator mt-4 mb-3">
              Dane Spółki
            </h2>
            <h2
              v-else-if="field === 'shares_person_firstname'"
              class="modal-table-separator mt-4 mb-3">
              Dane osoby, której przysługują udziały
            </h2>
            <hr
              v-else-if="getIsSectionSeparator(fieldIndex)"
              class="section-separator-line my-4">
            <hr v-else-if="fieldIndex > 0">
            <d-row>
              <d-col xs="5" class="text-right"><strong>{{ getFieldLabel(field) }}</strong></d-col>
              <d-col xs="5" offset-xs="6" class="text-left">{{ getFieldValueForDisplay(field) }}</d-col>
            </d-row>
          </template>

          <h2 class="modal-table-separator mt-5">
            Pliki
          </h2>
          <table class="table mb-0 border-top-0 responsive-table bg-gray">
            <thead>
              <tr>
                <th scope="col" class="border-0 id-cell">ID</th>
                <th scope="col" class="border-0">Typ dokumentu</th>
                <th scope="col" class="border-0">Plik</th>
                </tr>
            </thead>
            <tbody>
              <tr
                v-for="(document, index) in guarantee.files"
                :key="document.id">
                <td>
                  <dt>ID</dt>
                  <dd>{{ document.id }}</dd>
                </td>
                <td>
                  <dt>Rodzaj</dt>
                  <dd>
                    {{ getFileTypeLabel(document.type) }}
                  </dd>
                </td>
                <td>
                  <dt>Plik</dt>
                  <dd>
                    <a href="#" @click.prevent="downloadFile(document)">{{ document.filename}}</a>
                  </dd>
                </td>
              </tr>
              <tr v-if="guarantee.files.length === 0">
              <td
                :colspan="3"
                class="text-center text-info">
                Brak dokumentów do wyświetlenia&hellip;
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- FOOTER -->
        <div slot = "modal-footer">
            <d-button @click.prevent="$emit('update:show', false)" theme="danger">Zamknij</d-button>
        </div>
    </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal';
import FileSaver from 'file-saver';
import GuaranteeUtils from '@/utils/guarantee.js';

export default {
  name: 'GuaranteeModalReadonly',
  components: {
    SsModal
  },
  props: {
    props: {
      type: Object,
      default: ()=> {}
    },
    show: {
      type: Boolean,
      default: false
    },
    guarantors: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    props: {
      handler: function (to) {
        this.setupForm(to)
      },
      deep: true
    },
    show(to) {
      this.modal = to;
    },
  },
  data () {
    return {
      fieldsForType: [],
      filesTypes: [],
      guarantee: null,
      modal: false
    }
  },
  mounted () {
    this.modal = this.show;
    this.guarantee = this.props;
    this.filesTypes = GuaranteeUtils.getAvailableFilesTypes();
    this.setupForm(this.props);
  },
  methods: {
    toNumber (number) {
      return Vue.toNumber(number);
    },
    downloadFile (doc) {
      axios.post('api/payment-guarantees/download-payment-guarantee-document',
        { id: doc.id },
        { responseType: 'blob' }
      ).then(response => {
        let blob = new File([response.data], doc.filename );
        FileSaver.saveAs(blob);
      }).catch((error)=>{
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
      });
    },
    setupForm (newGuarantee) {
      if (!newGuarantee) {
        this.guarantee = {};
        this.fieldsForType = [];
        return;
      }

      this.guarantee = newGuarantee;
      this.fieldsForType = GuaranteeUtils.getFieldsForType(newGuarantee.type, newGuarantee, true);
    },
    getFieldLabel (field) {
      return GuaranteeUtils.getFieldLabel(this.guarantee, field);
    },
    getFieldValueForDisplay (field) {
      return GuaranteeUtils.getFieldValueForDisplay(this.guarantee, field, this.guarantors);
    },
    getFileTypeLabel (fileType) {
      if (!fileType) {
        return 'Inne';
      }
      let item = this.filesTypes.find(item => item.fileType === fileType);
      if (item) {
        return item.label;
      }

      return '-';
    },
    getIsSectionSeparator (fieldIndex) {
      if (this.fieldsForType.includes('shares_person_marital_status_other')) {
        return this.fieldsForType[fieldIndex - 1] === 'shares_person_marital_status_other';
      }

      if (this.fieldsForType.includes('shares_person_property_separation')) {
        return this.fieldsForType[fieldIndex - 1] === 'shares_person_property_separation';
      }

      if (this.fieldsForType.includes('shares_person_marital_status')) {
        return this.fieldsForType[fieldIndex - 1] === 'shares_person_marital_status';
      }

      if (this.fieldsForType[fieldIndex - 1] === 'company_province') {
        return true;
      }

      if (!this.fieldsForType.includes('pledge_type')) {
        return false;
      }

      if (this.fieldsForType[fieldIndex - 1] === 'city') {
        return true;
      }

      return false;
    }
  }
}
</script>

<style scoped>
.section-separator {
  /* border-bottom: 1px solid #3D5170; */
  /* border-top: 1px solid #3D5170; */
  color: #3D5170;
  font-weight: bold;
  background-color: #f8f8f8;
}

.section-separator-line {
  border-color: #3D5170;
}
</style>
